import fetch from './fetch';
import EndPoints from '../data/EndPoints';
import Methods from '../data/Methods';

// Not an actual call, but to prove
export default (id, data) => {
	return fetch(Methods.POST, EndPoints.EXPENSE_UPDATE.replace(':id', id), data, null, true);
};
